// オプション選択によるフォーム数の変更
document.addEventListener('variant:changed', changeInputForm);
document.addEventListener('DOMContentLoaded', changeInputForm);

// 要素のテキストを安全に取得するヘルパー関数
function getElementText(selector) {
    const element = document.querySelector(selector);
    if (element && element.innerText) {
        return element.innerText.trim() || '';
    }
    return '';
}

function changeInputForm(event) {
    const isVariantChange = event.type === 'variant:changed';
    const productTitle = getElementText('.ProductMeta__Title');
    const productHandle = getElementText('#product_handle');

    // フォームの更新を行う関数
    function updateForm(config) {
        const {
            input1,
            input2,
            input3,
            input4
        } = config;

        // Input 1
        if (input1) {
            const input1El = document.getElementById('input_1');
            const label1El = document.getElementById('lbl_input_1');
            if (input1El) {
                input1El.placeholder = input1.placeholder;
                input1El.parentElement.style.display = input1.visible ? 'block' : 'none';
                if (input1.label) {
                    input1El.name = `properties[${input1.label}]`;
                } else {
                    input1El.name = ``;
                }

                // required属性の設定
                if (input1.required) {
                    input1El.required = true;
                } else {
                    input1El.required = false;
                }
            }
            if (label1El) label1El.innerText = input1.label;
        }

        // Input 2
        if (input2) {
            const input2El = document.getElementById('input_2');
            const label2El = document.getElementById('lbl_input_2');
            if (input2El) {
                input2El.placeholder = input2.placeholder;
                input2El.parentElement.style.display = input2.visible ? 'block' : 'none';
                if (input2.label) {
                    input2El.name = `properties[${input2.label}]`;
                } else {
                    input2El.name = ``;
                }

                // required属性の設定
                if (input2.required) {
                    input2El.required = true;
                } else {
                    input2El.required = false;
                }
            }
            if (label2El) label2El.innerText = input2.label;
        }

        // Input 3
        if (input3 !== undefined) {
            const input3El = document.getElementById('input_3');
            const label3El = document.getElementById('lbl_input_3');
            if (input3El) {
                input3El.placeholder = input3.placeholder || '';
                input3El.parentElement.style.display = input3.visible ? 'block' : 'none';
                if (input3.label) {
                    input3El.name = `properties[${input3.label}]`;
                } else {
                    input3El.name = ``;
                }

                // required属性の設定
                if (input3.required) {
                    input3El.required = true;
                } else {
                    input3El.required = false;
                }
            }
            if (label3El) label3El.innerText = input3.label || '';
        }

        // Input 4
        if (input4 !== undefined) {
            const input4El = document.getElementById('input_4');
            const label4El = document.getElementById('lbl_input_4');
            if (input4El) {
                input4El.placeholder = input4.placeholder || '';
                input4El.parentElement.style.display = input4.visible ? 'block' : 'none';
                if (input4.label) {
                    input4El.name = `properties[${input4.label}]`;
                } else {
                    input4El.name = ``;
                }

                // required属性の設定
                if (input4.required) {
                    input4El.required = true;
                } else {
                    input4El.required = false;
                }
            }
            if (label4El) label4El.innerText = input4.label || '';
        }
    }

    // バリアント値を取得
    function getVariantValue(optionIndex = 0) {
        if (isVariantChange && event.detail && event.detail.variant) {
            return event.detail.variant.options[optionIndex] || '';
        }
        const selectedValues = document.getElementsByClassName('ProductForm__SelectedValue');
        if (selectedValues[optionIndex] && selectedValues[optionIndex].innerText) {
            return selectedValues[optionIndex].innerText || '';
        }
        return '';
    }

    // Fika
    if (productHandle.includes('fika')) {
        const variant = getVariantValue(1);
        console.log(variant);
        if (variant.includes('【A】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（番地）',
                    placeholder: '表札に載せる文字を入力してください（番地）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【B】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【C】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input2: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【D】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【E】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【F】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（1世帯目、漢字）',
                    placeholder: '表札に載せる文字を入力してください（1世帯目、漢字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（1世帯目、英字）',
                    placeholder: '表札に載せる文字を入力してください（1世帯目、英字）',
                    required: true
                },
                input3: {
                    visible: true,
                    label: '表札に載せる文字（2世帯目、漢字）',
                    placeholder: '表札に載せる文字を入力してください（2世帯目、漢字）',
                    required: true
                },
                input4: {
                    visible: true,
                    label: '表札に載せる文字（2世帯目、英字）',
                    placeholder: '表札に載せる文字を入力してください（2世帯目、英字）',
                    required: true
                }
            });
        } else {
            updateForm({
                input1: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input2: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        }
    }

    // Roots A
    else if (productHandle.includes('roots-1')) {
        const variant = getVariantValue(1);
        if (variant.includes('番地プレートなし')) {
            updateForm({
                input1: {
                    visible: true,
                    label: 'お名前',
                    placeholder: '表札に載せるお名前を入力してください',
                    required: true
                },
                input2: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('あり')) {
            updateForm({
                input1: {
                    visible: true,
                    label: 'お名前',
                    placeholder: '表札に載せるお名前を入力してください',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '番地（プレート）',
                    placeholder: '表札に載せる番地を入力してください',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        }
    }

    // Roots B
    else if (productHandle.includes('roots-2')) {
        updateForm({
            input1: {
                visible: true,
                label: 'お名前（切文字）',
                placeholder: '表札に載せるお名前を入力してください',
                required: true
            },
            input2: {
                visible: true,
                label: '番地（プレート）',
                placeholder: '表札に載せる番地を入力してください',
                required: true
            },
            input3: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input4: {
                visible: false,
                label: '',
                placeholder: ''
            }
        });
    }

    // Roots C
    else if (productHandle.includes('roots-3')) {
        updateForm({
            input1: {
                visible: true,
                label: 'お名前（切文字）',
                placeholder: '表札に載せるお名前を入力してください',
                required: true
            },
            input2: {
                visible: true,
                label: '番地（プレート）',
                placeholder: '表札に載せる番地を入力してください',
                required: true
            },
            input3: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input4: {
                visible: false,
                label: '',
                placeholder: ''
            }
        });
    }

    // Roots D
    else if (productHandle.includes('roots-4')) {
        updateForm({
            input1: {
                visible: true,
                label: 'お名前（切文字）',
                placeholder: '表札に載せるお名前を入力してください',
                required: true
            },
            input2: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input3: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input4: {
                visible: false,
                label: '',
                placeholder: ''
            }
        });
    }


    // Bridge
    else if (productHandle.includes('bridge')) {
        updateForm({
            input1: {
                visible: true,
                label: '表札に載せる文字',
                placeholder: '表札に載せる文字を入力してください',
                required: true
            },
            input2: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input3: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input4: {
                visible: false,
                label: '',
                placeholder: ''
            }
        });
    }

    // Tailor
    else if (productHandle.includes('tailor')) {
        if (productHandle.includes('signboard')) {
            updateForm({
                input1: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input2: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else {
            const variant = getVariantValue(1);
            if (variant.includes('【A】') || variant.includes('【C】')) {
                updateForm({
                    input1: {
                        visible: true,
                        label: '表札に載せるお名前',
                        placeholder: '表札に載せるお名前を入力してください',
                        required: true
                    },
                    input2: {
                        visible: true,
                        label: '表札に載せる文字（番地）',
                        placeholder: '表札に載せる文字を入力してください（番地）',
                        required: true
                    },
                    input3: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    },
                    input4: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    }
                });
            } else if (variant.includes('【B】') || variant.includes('【D】')) {
                updateForm({
                    input1: {
                        visible: true,
                        label: '表札に載せるお名前',
                        placeholder: '表札に載せるお名前を入力してください',
                        required: true
                    },
                    input2: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    },
                    input3: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    },
                    input4: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    }
                });
            } else if (variant.includes('【E】') || variant.includes('【G】') || variant.includes('【H】')) {
                updateForm({
                    input1: {
                        visible: true,
                        label: '表札に載せるお名前',
                        placeholder: '表札に載せるお名前を入力してください',
                        required: true
                    },
                    input2: {
                        visible: true,
                        label: '表札に載せる番地',
                        placeholder: '表札に載せる番地を入力してください',
                        required: true
                    },
                    input3: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    },
                    input4: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    }
                });
            } else if (variant.includes('【F】')) {
                updateForm({
                    input1: {
                        visible: true,
                        label: '表札に載せるお名前',
                        placeholder: '表札に載せるお名前を入力してください',
                        required: true
                    },
                    input2: {
                        visible: true,
                        label: '表札に載せる住所（英語）',
                        placeholder: '表札に載せる住所を入力してください（英語）',
                        required: true
                    },
                    input3: {
                        visible: true,
                        label: '表札に載せる番地',
                        placeholder: '表札に載せる番地を入力してください',
                        required: true
                    },
                    input4: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    }
                });
            } else {
                updateForm({
                    input1: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    },
                    input2: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    },
                    input3: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    },
                    input4: {
                        visible: false,
                        label: '',
                        placeholder: ''
                    }
                });
            }
        }
    }

    // Piece
    else if (productHandle.includes('piece')) {
        const variant = getVariantValue(1);
        if (variant.includes('【A】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（番地）',
                    placeholder: '表札に載せる文字を入力してください（番地）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【B】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字',
                    placeholder: '表札に載せる文字を入力してください',
                    required: true
                },
                input2: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【C】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（番地）',
                    placeholder: '表札に載せる文字を入力してください（番地）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【D】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        }
    }

    // Oliver
    else if (productHandle.includes('oliver-n')) {
        const variant = getVariantValue(0);
        if (variant.includes('【A】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【B】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（番地）',
                    placeholder: '表札に載せる文字を入力してください（番地）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【C】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input2: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【D】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input2: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        }
    }

    else if (productHandle.includes('kino')) {
        const variant = getVariantValue(0);
        if (variant.includes('タモ')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('サクラ')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（番地）',
                    placeholder: '表札に載せる文字を入力してください（番地）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('エンジュ')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        }
    }


    // 下記3つは現状互換のためのコード
    // Kino（タモ）
    else if (productTitle.includes('Kino（タモ）')) {
        updateForm({
            input1: {
                visible: true,
                label: '表札に載せる文字（漢字）',
                placeholder: '表札に載せる文字を入力してください（漢字）',
                required: true
            },
            input2: {
                visible: true,
                label: '表札に載せる文字（英字）',
                placeholder: '表札に載せる文字を入力してください（英字）',
                required: true
            },
            input3: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input4: {
                visible: false,
                label: '',
                placeholder: ''
            }
        });
    }

    // Kino（サクラ）
    else if (productTitle.includes('Kino（サクラ）')) {
        updateForm({
            input1: {
                visible: true,
                label: '表札に載せる文字（英字）',
                placeholder: '表札に載せる文字を入力してください（英字）',
                required: true
            },
            input2: {
                visible: true,
                label: '表札に載せる文字（番地）',
                placeholder: '表札に載せる文字を入力してください（番地）',
                required: true
            },
            input3: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input4: {
                visible: false,
                label: '',
                placeholder: ''
            }
        });
    }

    // Kino（エンジュ）
    else if (productTitle.includes('Kino（エンジュ）')) {
        updateForm({
            input1: {
                visible: true,
                label: '表札に載せる文字（漢字）',
                placeholder: '表札に載せる文字を入力してください（漢字）',
                required: true
            },
            input2: {
                visible: true,
                label: '表札に載せる文字（英字）',
                placeholder: '表札に載せる文字を入力してください（英字）',
                required: true
            },
            input3: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input4: {
                visible: false,
                label: '',
                placeholder: ''
            }
        });
    }

    // Mark
    else if (productHandle.includes('mark')) {
        const variant = getVariantValue(1);
        if (variant.includes('番地プレートなし')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字',
                    placeholder: '表札に載せる文字を入力してください',
                    required: true
                },
                input2: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('番地プレートあり')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（お名前）',
                    placeholder: '表札に載せる文字を入力してください（お名前）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（番地）',
                    placeholder: '表札に載せる文字を入力してください（番地）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        }
    }

    // Barley
    else if (productHandle.includes('barley')) {
        const variant = getVariantValue(1);
        if (variant.includes('【A】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字(英字)',
                    placeholder: '表札に載せる文字を入力してください(英字)',
                    required: true
                },
                input2: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【B】') || variant.includes('【E】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【D】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（漢字）',
                    placeholder: '表札に載せる文字を入力してください（漢字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('【C】') || variant.includes('【F】')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せる文字を入力してください（英字）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（番地）',
                    placeholder: '表札に載せる文字を入力してください（番地）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        }
    }

    // Links
    else if (productHandle.includes('ne-lnk')) {
        const variant = getVariantValue(1);
        if (variant.includes('番地プレートなし')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字',
                    placeholder: '表札に載せる文字を入力してください',
                    required: true
                },
                input2: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('番地プレートあり')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（お名前）',
                    placeholder: '表札に載せる文字を入力してください（お名前）',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '表札に載せる文字（番地）',
                    placeholder: '表札に載せる文字を入力してください（番地）',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        }
    }

    // Jack
    else if (productHandle.includes('jack')) {
        updateForm({
            input1: {
                visible: true,
                label: '表札に載せる文字',
                placeholder: '表札に載せる文字を入力してください',
                required: true
            },
            input2: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input3: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input4: {
                visible: false,
                label: '',
                placeholder: ''
            }
        });
    }

    // Zira
    else if (productHandle.includes('zira')) {
        updateForm({
            input1: {
                visible: true,
                label: '表札に載せる文字（英字）',
                placeholder: '表札に載せるお名前を入力してください',
                required: true
            },
            input2: {
                visible: true,
                label: '番地（プレート）',
                placeholder: '表札に載せる番地を入力してください'
            },
            input3: {
                visible: false,
                label: '',
                placeholder: ''
            },
            input4: {
                visible: false,
                label: '',
                placeholder: ''
            }
        });
    }

    // Jealous
    else if (productHandle.includes('jus')) {
        const variant = getVariantValue(1);
        if (variant.includes('台板01：番地のみ')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せるお名前を入力してください',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '台板に載せる番地',
                    placeholder: '台板に載せる番地を入力してください',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: ''
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('台板02：名前のみ')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せるお名前を入力してください',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '台板に載せる文字（漢字）',
                    placeholder: '台板に載せる文字を入力してください',
                    required: true
                },
                input3: {
                    visible: false,
                    label: '',
                    placeholder: '',
                    required: false
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        } else if (variant.includes('台板03：番地+名前')) {
            updateForm({
                input1: {
                    visible: true,
                    label: '表札に載せる文字（英字）',
                    placeholder: '表札に載せるお名前を入力してください',
                    required: true
                },
                input2: {
                    visible: true,
                    label: '台板に載せる番地',
                    placeholder: '台板に載せる番地を入力してください',
                    required: true
                },
                input3: {
                    visible: true,
                    label: '台板に載せる文字（漢字）',
                    placeholder: '台板に載せる文字を入力してください',
                    required: true
                },
                input4: {
                    visible: false,
                    label: '',
                    placeholder: ''
                }
            });
        }
    }
}

// fixedボタンの表示制御
window.addEventListener('scroll', function () {
    if (600 < window.scrollY) {
        document.getElementById('bottom_fixed_wrapper').style.visibility = 'visible';
        document.getElementById('bottom_fixed_wrapper').style.opacity = '1';
    } else {
        document.getElementById('bottom_fixed_wrapper').style.visibility = 'hidden';
        document.getElementById('bottom_fixed_wrapper').style.opacity = '0';
    }
});

// 入力フォームのvalidation
var text_input = document.getElementsByClassName('ProductForm__Item__Custom');
for (var i = 0; i < text_input.length; i++) {
    if (text_input[i].required == true) {
        text_input[i].addEventListener('change', {
            type: 'change',
            handleEvent: changeTextForm,
            el: text_input[i]
        }, false);
    }
}

function changeTextForm(e) {
    var input = this.el.value;
    var validate_txt = this.el.parentElement.nextElementSibling;
    if (input == '') {
        this.el.classList.add('is-null');
        validate_txt.classList.add('is-null');
    } else {
        this.el.classList.remove('is-null');
        validate_txt.classList.remove('is-null');
    }
}

// $('[data-option="option1"]').change(function(){
//   console.log(this.value)
//   if (this.value === 'No Initials') {
//    document.getElementById('initials').parentElement.style.display = 'none';
//   } else {
//    document.getElementById('initials').parentElement.removeAttribute('style');
//   }
// })

// レビュー部分スムーススクロール
$(document).ready(function () {
    $('a[href^="#judgeme_product_reviews"]').on('click', function (e) {
        e.preventDefault();

        var target = this.hash;
        var $target = $(target);

        $('html, body').stop().animate({
                scrollTop: $target.offset().top,
            },
            1000,
            'swing'
        );
    });
});

// 商品詳細のアコーディオン
$(document).ready(function () {
    $('.Product__accordion-button').click(function () {
        var content = $(this).next('.Product__accordion-content');

        if (content.is(':visible')) {
            $(this).removeClass('rotate-arrow');
        } else {
            $(this).addClass('rotate-arrow');
        }

        content.slideToggle(300);
    });
});
